<template>
  <!-- 课堂互动发布 -->
  <div class="publish-Class">
    <a-form :form="formData" style="border:0px solid #f00; overflow:auto;">
      <div class="form-left">
        <a-form-item label="课堂互动标题" :label-col="{ span: 7 }" :wrapper-col="{ span: 12 }">
          <a-input v-model="formData.title" style="width:180px;" placeholder="请输入标题" />
        </a-form-item>

        <a-form-item label="描述" :label-col="{ span: 7 }" :wrapper-col="{ span: 12 }">
          <a-textarea v-model="formData.description" placeholder="请输入课堂互动描述" :rows="3" />
        </a-form-item>

        <a-form-item label="班级" :label-col="{ span: 7 }" :wrapper-col="{ span: 12 }">
          <a-checkbox-group :options="classData" :defaultValue="formData.classids" @change="changeClass">
            <span slot="label" slot-scope="{value}">{{value}}</span>
          </a-checkbox-group>
        </a-form-item>

        <a-form-item label="发布时间" :label-col="{ span: 7 }" :wrapper-col="{ span: 12 }">
          <a-date-picker :defaultValue="formData.startTime ? $moment(formData.startTime) : null" format="YYYY-MM-DD HH:mm:ss" showTime placeholder="选择发布时间" @change="onChangePublish" style="width: 180px;" />
        </a-form-item>
        <!-- <a-form-item label="截止时间" :label-col="{ span: 7 }" :wrapper-col="{ span: 12 }">
                    <a-date-picker :defaultValue="formData.execiseendtime ? $moment(formData.execiseendtime) : null" format="YYYY-MM-DD HH:mm:ss" showTime placeholder="选择截止时间" @change="onChangeEnd" style="width: 180px;" />
                </a-form-item> -->
      </div>
    </a-form>

    <div class="bottom-button">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" :loading="loading" @click="publishAssembly">确认</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "publish-Class",
  data () {
    return {
      formData: {
        bankid: "",
        teachid: this.$store.getters.id,
        title: "",
        description: "",
        classids: [],
        questIdTags: [],
        startTime: "",
      },
      classData: [],
      classIds: [],
      pageList: [],
      loading: false
    };
  },
  methods: {
    getClass () {
      this.$http
        .get("v1/learnonly/teachingAssistant/showUserClasses", {
          params: { userid: this.$store.getters.id, typeid: 1 }
        })
        .then(response => {
          this.classData = [];
          this.classIds = [];
          if (response.data) {
            for (let [k, v] of Object.entries(response.data)) {
              this.classData.push({ value: Number(k), label: v });
              this.classIds.push(Number(k));
            }
          }
        });
    },
    changeClass (value) {
      this.formData.classids = value;
    },
    getQuesId (data) {
      data.forEach(i => {
        this.formData.questIdTags.push({
          questId: i.questionId,
          tag: i.tag
        })
      });
    },
    onChangePublish (value, dateString) {
      this.formData.startTime = dateString
    },
    // onChangeEnd(value, dateString) {
    //     this.formData.execiseendtime = dateString
    // },
    publishAssembly () {
      if (this.formData.title == "") {
        this.$message.error("请输入标题");
        return;
      }
      if (this.formData.classids.length == 0) {
        this.$message.error("请选择班级");
        return;
      }
      if (this.formData.startTime == "") {
        this.$message.error("请选择发布时间");
        return;
      }
      this.loading = true;
      this.$http
        .post("v1/learnonly/teach/save/exercise", {
          exerciseInfo: JSON.stringify(this.formData)
        })
        .then(response => {
          if (response.data) {
            this.$message.success(response.data.success);
          } else {
            this.$message.error("发布失败")
          }
          this.$emit("incre");
        });
    },
    cancel () {
      this.$emit("incre");
    }
  },
  created () {
    this.getClass();
    this.formData.bankid = this.$route.query.bankid;
    this.pageList = JSON.parse(localStorage.getItem("pageList"));
    this.getQuesId(this.pageList);
  }
}
</script>

<style scoped>
.publish-Class {
  width: 100%;
  height: auto;
  overflow: auto;
}
.form-left {
  width: 55%;
  height: auto;
  float: left;
  clear: both;
  padding-right: 20px;
}
.form-right {
  width: 40%;
  height: auto;
  float: left;
}
.form-right .head {
  margin-bottom: 20px;
}
.form-right .content-box {
  border: 1px solid #ccc;
  padding: 20px;
  height: 300px;
  overflow-y: scroll;
}
.bottom-button {
  text-align: center;
}
.ant-form-item {
  margin-bottom: 5px;
  width: 364px;
}
</style>


